"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceStatusComputedMapping = void 0;
/**
 * Shared Elasticsearch mapping for computed invoice status.
 *
 * This script calculates invoice status dynamically based on multiple fields:
 * - DELETED: Voided invoice without an issue date
 * - VOID: Voided invoice with an issue date
 * - PAID: Invoice marked as paid in full
 * - DRAFT: Invoice without an issue date or with future issue date
 * - PAST_DUE: Invoice past its due date
 * - PARTIALLY_PAID: Invoice with payments but not paid in full
 * - PARTIALLY_REFUNDED: Invoice with refunds resulting in negative balance
 * - REFUNDED: Invoice fully refunded (balance = 0)
 * - ISSUED: Default status for issued invoices
 *
 * Used by: sourgum-payable, sourgum-receivable, wayste-receivable
 */
exports.InvoiceStatusComputedMapping = {
    field: 'invoiceDetails.status_computed',
    elasticMapping: {
        type: 'keyword',
        script: {
            source: `
        String status = 'ISSUED';

        if (doc.containsKey('invoiceDetails.void') && doc['invoiceDetails.void'].size() > 0 && doc['invoiceDetails.void'].value) {
          if (!doc.containsKey('invoiceDetails.issueDate') || doc['invoiceDetails.issueDate'].size() == 0) {
            status = 'DELETED';
          } else {
            status = 'VOID';
          }
        } else if (doc.containsKey('invoiceDetails.paidInFull') && doc['invoiceDetails.paidInFull'].size() > 0 && doc['invoiceDetails.paidInFull'].value) {
          status = 'PAID';
        } else if (!doc.containsKey('invoiceDetails.issueDate') || doc['invoiceDetails.issueDate'].size() == 0) {
          status = 'DRAFT';
        } else {
          long issueDateTime = doc['invoiceDetails.issueDate'].value.toInstant().toEpochMilli();
          long now = new Date().getTime();

          if (issueDateTime > now) {
            status = 'DRAFT';
          } else if (doc.containsKey('invoiceDetails.dueDate') && doc['invoiceDetails.dueDate'].size() > 0) {
            long dueDateTime = doc['invoiceDetails.dueDate'].value.toInstant().toEpochMilli();
            if (dueDateTime < now) {
              status = 'PAST_DUE';
            }
          }

          if (status == 'ISSUED') {
            if (doc.containsKey('invoiceDetails.payments.amount') && doc['invoiceDetails.payments.amount'].size() > 0) {
              boolean notPaidInFull = !doc.containsKey('invoiceDetails.paidInFull') || doc['invoiceDetails.paidInFull'].size() == 0 || !doc['invoiceDetails.paidInFull'].value;
              if (notPaidInFull && doc.containsKey('invoiceDetails.remainingBalance') && doc['invoiceDetails.remainingBalance'].size() > 0 && doc['invoiceDetails.remainingBalance'].value > 0) {
                status = 'PARTIALLY_PAID';
              }
            }

            if (status == 'ISSUED' && doc.containsKey('invoiceDetails.refunds.amount') && doc['invoiceDetails.refunds.amount'].size() > 0 && doc.containsKey('invoiceDetails.remainingBalance') && doc['invoiceDetails.remainingBalance'].size() > 0) {
              if (doc['invoiceDetails.remainingBalance'].value < 0) {
                status = 'PARTIALLY_REFUNDED';
              } else if (doc['invoiceDetails.remainingBalance'].value == 0) {
                status = 'REFUNDED';
              }
            }
          }
        }

        emit(status);
      `,
            lang: 'painless',
        },
    },
};
//# sourceMappingURL=invoice-status-computed-mapping.js.map